export default __webpack_public_path__ + "static/media/resnetgru2.57e9661d.png";